import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Text } from '../../../components/text'

import { Color } from '../../../theme/color'

interface ContentItemProps {
  imgUri: string
  title: string
  href: string
  width?: number
  line?: number
}

export function ContentItem({ imgUri, title, href, width, line }: ContentItemProps) {
  return (
    <Link to={href}>
      <Container line={line} width={width}>
        <ImgBox>
          <img src={imgUri} alt={title} />
        </ImgBox>
        <Text size={16} weight={500} {...(line === 1 && { $textOverflow: 'ellipsis' })}>
          {title}
        </Text>
      </Container>
    </Link>
  )
}

const Container = styled.div<Pick<ContentItemProps, 'width' | 'line'>>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ width }) => `width: ${width}px;`}
  ${({ line }) =>
    typeof line === 'number' && line > 1
      ? `span {
          display: -webkit-box;
          overflow: hidden;
          width: 100%;
          height: ${19 * line}px;
          min-height: 38px;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: ${line};
        }`
      : ''}
`

const ImgBox = styled.div`
  overflow: hidden;
  width: 100%;
  border: 1px solid ${Color.line};
  border-radius: 8px;
  aspect-ratio: 1 / 1;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
